import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
@Directive({
    selector: '[emailRestrict]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmailRestrictDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class EmailRestrictDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(control.value)
     ? null
     : { invalid : true };
 }
 
 

}